import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../auth.service';

@Component({
    selector: 'tdms-broker-callback',
    templateUrl: './callback.component.html',
    styleUrls: ['./callback.component.scss'],
    standalone: false
})
export class BrokerCallbackComponent implements OnInit {

  constructor(private auth: AuthService, private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
      const referrer = this.route.snapshot.queryParamMap.get('referrer');

      // studiousersignup 400s on this endpoint when either param is absent, so avoid calling it
      if (!referrer) {
        console.error('Broker callback missing referrer');
        this.auth.login();
        return;
      } else {
        // full page navigation so the request actually goes over the network (and through the proxy) instead of client-side routing
        const proxyUrl = this.router.url.replace('/callback/broker', '/api/cb') ;
        window.location.href = proxyUrl;
      }
  }

}
